module.exports = new __parcel__URL__("wizard-eldwin.9895eb70.webp").toString();